// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ACID_RAIN_TALENT: {
    id: 378443,
    name: 'Acid Rain',
    icon: 'spell_nature_acid_01',
    maxRanks: 1,
    entryIds: [101922],
    definitionIds: [{ id: 106910, specId: 264 }],
  },
  AFTERSHOCK_TALENT: {
    id: 273221,
    name: 'Aftershock',
    icon: 'spell_nature_stormreach',
    maxRanks: 1,
    entryIds: [101873],
    definitionIds: [{ id: 106830, specId: 262 }],
  },
  AMPED_UP_TALENT: {
    id: 1269360,
    name: 'Amped Up',
    icon: 'inv_10_elementalcombinedfoozles_lightning',
    maxRanks: 1,
    entryIds: [127919],
    definitionIds: [{ id: 132728, specId: 262 }],
  },
  AMPLIFICATION_CORE_TALENT: {
    id: 445029,
    name: 'Amplification Core',
    icon: 'ability_evoker_essenceburststacks',
    maxRanks: 1,
    entryIds: [117471],
    definitionIds: [{ id: 122483, specId: 264 }],
  },
  ANCESTRAL_AWAKENING_TALENT: {
    id: 382309,
    name: 'Ancestral Awakening',
    icon: 'spell_shaman_ancestralawakening',
    maxRanks: 2,
    entryIds: [101927],
    definitionIds: [{ id: 106914, specId: 264 }],
  },
  ANCESTRAL_INFLUENCE_TALENT: {
    id: 1270446,
    name: 'Ancestral Influence',
    icon: 'shaman_pvp_leaderclan',
    maxRanks: 1,
    entryIds: [135990],
    definitionIds: [{ id: 140745, specId: 264 }],
  },
  ANCESTRAL_REACH_TALENT: {
    id: 382732,
    name: 'Ancestral Reach',
    icon: 'inv_1115_shaman_chainheal',
    maxRanks: 1,
    entryIds: [101911],
    definitionIds: [{ id: 106944, specId: 264 }],
  },
  ANCESTRAL_SWIFTNESS_TALENT: {
    id: 448861,
    name: 'Ancestral Swiftness',
    icon: 'inv_ability_farseershaman_ancestralswiftness',
    maxRanks: 1,
    entryIds: [117491],
    definitionIds: [{ id: 122503, specId: 264 }],
  },
  ANCESTRAL_VIGOR_TALENT: {
    id: 207401,
    name: 'Ancestral Vigor',
    icon: 'spell_shaman_blessingoftheeternals',
    maxRanks: 2,
    entryIds: [127673],
    definitionIds: [{ id: 132482, specId: 264 }],
  },
  ANCESTRAL_WOLF_AFFINITY_TALENT: {
    id: 382197,
    name: 'Ancestral Wolf Affinity',
    icon: 'spell_beastmaster_wolf',
    maxRanks: 1,
    entryIds: [127886],
    definitionIds: [{ id: 132695, specId: 264 }],
  },
  ANCIENT_FELLOWSHIP_TALENT: {
    id: 443423,
    name: 'Ancient Fellowship',
    icon: 'spell_shaman_astralshift',
    maxRanks: 1,
    entryIds: [123632],
    definitionIds: [{ id: 128470, specId: 264 }],
  },
  ARCTIC_SNOWSTORM_TALENT: {
    id: 462764,
    name: 'Arctic Snowstorm',
    icon: 'spell_frost_glacier',
    maxRanks: 1,
    entryIds: [135717],
    definitionIds: [{ id: 140472, specId: 264 }],
  },
  ARC_DISCHARGE_TALENT: {
    id: 455096,
    name: 'Arc Discharge',
    icon: 'ability_thunderking_balllightning',
    maxRanks: 1,
    entryIds: [117482],
    definitionIds: [{ id: 122494, specId: 263 }],
  },
  ASCENDANCE_ELEMENTAL_TALENT: {
    id: 114050,
    name: 'Ascendance',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [101860],
    definitionIds: [{ id: 106820, specId: 262 }],
  },
  ASCENDANCE_ENHANCEMENT_TALENT: {
    id: 114051,
    name: 'Ascendance',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [114291],
    definitionIds: [{ id: 119296, specId: 263 }],
  },
  ASCENDANCE_RESTORATION_TALENT: {
    id: 114052,
    name: 'Ascendance',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [101912],
    definitionIds: [{ id: 106942, specId: 264 }],
  },
  ASCENDING_AIR_TALENT: {
    id: 462791,
    name: 'Ascending Air',
    icon: 'achievement_raidprimalist_windelemental',
    maxRanks: 1,
    entryIds: [127883],
    definitionIds: [{ id: 132692, specId: 264 }],
  },
  ASHEN_CATALYST_TALENT: {
    id: 390370,
    name: 'Ashen Catalyst',
    icon: 'spell_shaman_stormearthfire',
    maxRanks: 1,
    entryIds: [101811],
    definitionIds: [{ id: 106897, specId: 263 }],
  },
  ASTRAL_BULWARK_TALENT: {
    id: 377933,
    name: 'Astral Bulwark',
    icon: 'spell_shaman_ancestralawakening',
    maxRanks: 1,
    entryIds: [127887],
    definitionIds: [{ id: 132696, specId: 264 }],
  },
  ASTRAL_SHIFT_TALENT: {
    id: 108271,
    name: 'Astral Shift',
    icon: 'ability_shaman_astralshift',
    maxRanks: 1,
    entryIds: [127893],
    definitionIds: [{ id: 132702, specId: 264 }],
  },
  AWAKENING_STORMS_TALENT: {
    id: 455129,
    name: 'Awakening Storms',
    icon: 'spell_nature_stormreach',
    maxRanks: 1,
    entryIds: [117464],
    definitionIds: [{ id: 122476, specId: 263 }],
  },
  BRIMMING_WITH_LIFE_TALENT: {
    id: 381689,
    name: 'Brimming with Life',
    icon: 'inv_jewelry_talisman_06',
    maxRanks: 2,
    entryIds: [127855],
    definitionIds: [{ id: 132664, specId: 264 }],
  },
  CALL_OF_FIRE_TALENT: {
    id: 378255,
    name: 'Call of Fire',
    icon: 'spell_fire_elemental_totem',
    maxRanks: 1,
    entryIds: [101864],
    definitionIds: [{ id: 106846, specId: 262 }],
  },
  CALL_OF_THE_ANCESTORS_TALENT: {
    id: 443450,
    name: 'Call of the Ancestors',
    icon: 'ability_racial_ancestralcall',
    maxRanks: 1,
    entryIds: [117485],
    definitionIds: [{ id: 122497, specId: 264 }],
  },
  CALM_WATERS_TALENT: {
    id: 1252841,
    name: 'Calm Waters',
    icon: 'inv_10_elementalshardfoozles_water',
    maxRanks: 1,
    entryIds: [101896],
    definitionIds: [{ id: 106923, specId: 264 }],
  },
  CAPACITOR_TOTEM_TALENT: {
    id: 192058,
    name: 'Capacitor Totem',
    icon: 'spell_nature_brilliance',
    maxRanks: 1,
    entryIds: [127851],
    definitionIds: [{ id: 132660, specId: 264 }],
    manaCost: 5000,
  },
  CHAINING_STORMS_TALENT: {
    id: 334308,
    name: 'Chaining Storms',
    icon: 'spell_nature_chainlightning',
    maxRanks: 1,
    entryIds: [135254],
    definitionIds: [{ id: 140022, specId: 263 }],
  },
  CHAIN_HEAL_TALENT: {
    id: 1064,
    name: 'Chain Heal',
    icon: 'inv_1115_shaman_chainheal',
    maxRanks: 1,
    entryIds: [127861],
    definitionIds: [{ id: 132670, specId: 264 }],
    manaCost: 10700,
  },
  CHAIN_LIGHTNING_TALENT: {
    id: 188443,
    name: 'Chain Lightning',
    icon: 'spell_nature_chainlightning',
    maxRanks: 1,
    entryIds: [127856],
    definitionIds: [{ id: 132665, specId: 264 }],
  },
  CHARGED_CONDUIT_TALENT: {
    id: 468625,
    name: 'Charged Conduit',
    icon: 'ability_thunderking_thunderstruck',
    maxRanks: 1,
    entryIds: [101862],
    definitionIds: [{ id: 106844, specId: 262 }],
  },
  CLEANSE_SPIRIT_TALENT: {
    id: 51886,
    name: 'Cleanse Spirit',
    icon: 'ability_shaman_cleansespirit',
    maxRanks: 1,
    entryIds: [127884],
    definitionIds: [{ id: 132693, specId: 263 }],
    manaCost: 25000,
  },
  COALESCING_WATER_TALENT: {
    id: 470076,
    name: 'Coalescing Water',
    icon: 'inv_helm_mail_raidshamanmythic_s_01',
    maxRanks: 1,
    entryIds: [101925],
    definitionIds: [{ id: 106912, specId: 264 }],
  },
  CONDUCTIVE_ENERGY_TALENT: {
    id: 455123,
    name: 'Conductive Energy',
    icon: 'inv_rod_enchantedcobalt',
    maxRanks: 1,
    entryIds: [117465],
    definitionIds: [{ id: 122477, specId: 263 }],
  },
  CONVERGING_STORMS_TALENT: {
    id: 384363,
    name: 'Converging Storms',
    icon: 'warrior_talent_icon_stormbolt',
    maxRanks: 1,
    entryIds: [101839],
    definitionIds: [{ id: 106878, specId: 263 }],
  },
  CRACKLING_FURY_TALENT: {
    id: 1269215,
    name: 'Crackling Fury',
    icon: 'inv_10_dungeonjewelry_primalist_trinket_1ragingelement_air',
    maxRanks: 2,
    entryIds: [127914],
    definitionIds: [{ id: 132723, specId: 262 }],
  },
  CRASHING_WAVES_TALENT: {
    id: 1253090,
    name: 'Crashing Waves',
    icon: 'spell_nature_healingwavelesser',
    maxRanks: 1,
    entryIds: [136583],
    definitionIds: [{ id: 141356, specId: 264 }],
  },
  CRASH_LIGHTNING_TALENT: {
    id: 187874,
    name: 'Crash Lightning',
    icon: 'spell_shaman_crashlightning',
    maxRanks: 1,
    entryIds: [101840],
    definitionIds: [{ id: 106879, specId: 263 }],
  },
  CURRENT_CONTROL_TALENT: {
    id: 1253093,
    name: 'Current Control',
    icon: 'inv_misc_volatilewater',
    maxRanks: 1,
    entryIds: [101920],
    definitionIds: [{ id: 106908, specId: 264 }],
  },
  DEEPLY_ROOTED_ELEMENTS_TALENT: {
    id: 378270,
    name: 'Deeply Rooted Elements',
    icon: 'inv_misc_herb_liferoot_stem',
    maxRanks: 1,
    entryIds: [101816, 101937],
    definitionIds: [
      { id: 106894, specId: 263 },
      { id: 106936, specId: 264 },
    ],
  },
  DELUGE_TALENT: {
    id: 200076,
    name: 'Deluge',
    icon: 'ability_shawaterelemental_reform',
    maxRanks: 1,
    entryIds: [101919],
    definitionIds: [{ id: 106907, specId: 264 }],
  },
  DESCENDING_SKIES_TALENT: {
    id: 1264688,
    name: 'Descending Skies',
    icon: 'spell_nature_wispheal',
    maxRanks: 1,
    entryIds: [135985],
    definitionIds: [{ id: 140740, specId: 263 }],
  },
  DOOM_WINDS_TALENT: {
    id: 384352,
    name: 'Doom Winds',
    icon: 'ability_ironmaidens_swirlingvortex',
    maxRanks: 1,
    entryIds: [101824],
    definitionIds: [{ id: 106859, specId: 263 }],
  },
  DOUBLE_DIP_TALENT: {
    id: 1252882,
    name: 'Double Dip',
    icon: 'ability_mage_waterjet',
    maxRanks: 1,
    entryIds: [128703],
    definitionIds: [{ id: 133505, specId: 264 }],
  },
  DOWNPOUR_TALENT: {
    id: 462486,
    name: 'Downpour',
    icon: 'ability_mage_waterjet',
    maxRanks: 1,
    entryIds: [127682],
    definitionIds: [{ id: 132491, specId: 264 }],
  },
  EARTHEN_ACCORD_TALENT: {
    id: 1271104,
    name: 'Earthen Accord',
    icon: 'ability_evoker_earthensky',
    maxRanks: 1,
    entryIds: [136582],
    definitionIds: [{ id: 141355, specId: 264 }],
  },
  EARTHEN_COMMUNION_TALENT: {
    id: 443441,
    name: 'Earthen Communion',
    icon: 'spell_nature_skinofearth',
    maxRanks: 1,
    entryIds: [123631],
    definitionIds: [{ id: 128469, specId: 264 }],
  },
  EARTHEN_HARMONY_TALENT: {
    id: 382020,
    name: 'Earthen Harmony',
    icon: 'spell_shaman_improvedearthshield',
    maxRanks: 1,
    entryIds: [127674],
    definitionIds: [{ id: 132483, specId: 264 }],
  },
  EARTHEN_RAGE_TALENT: {
    id: 170374,
    name: 'Earthen Rage',
    icon: 'ability_earthen_pillar',
    maxRanks: 1,
    entryIds: [101887],
    definitionIds: [{ id: 106854, specId: 262 }],
  },
  EARTHGRAB_TOTEM_TALENT: {
    id: 51485,
    name: 'Earthgrab Totem',
    icon: 'spell_nature_stranglevines',
    maxRanks: 1,
    entryIds: [127902],
    definitionIds: [{ id: 132711, specId: 264 }],
  },
  EARTHLIVING_WEAPON_TALENT: {
    id: 382021,
    name: 'Earthliving Weapon',
    icon: 'spell_shaman_giftearthmother',
    maxRanks: 1,
    entryIds: [101935],
    definitionIds: [{ id: 106928, specId: 264 }],
  },
  EARTHQUAKE_1_ELEMENTAL_TALENT: {
    id: 462620,
    name: 'Earthquake',
    icon: 'spell_shaman_earthquake',
    maxRanks: 1,
    entryIds: [101855],
    definitionIds: [{ id: 106814, specId: 262 }],
    maelstromCost: 60,
  },
  EARTHQUAKE_2_ELEMENTAL_TALENT: {
    id: 61882,
    name: 'Earthquake',
    icon: 'spell_shaman_earthquake',
    maxRanks: 1,
    entryIds: [127925],
    definitionIds: [{ id: 132734, specId: 262 }],
    maelstromCost: 60,
  },
  EARTHSHATTER_TALENT: {
    id: 468626,
    name: 'Earthshatter',
    icon: 'spell_nature_earthquake',
    maxRanks: 1,
    entryIds: [101867],
    definitionIds: [{ id: 106821, specId: 262 }],
  },
  EARTHSURGE_TALENT: {
    id: 455590,
    name: 'Earthsurge',
    icon: 'inv_elementalearth2',
    maxRanks: 1,
    entryIds: [125822],
    definitionIds: [{ id: 130653, specId: 264 }],
  },
  EARTHWEAVER_TALENT: {
    id: 1254210,
    name: 'Earthweaver',
    icon: 'spell_nature_skinofearth',
    maxRanks: 1,
    entryIds: [101931],
    definitionIds: [{ id: 106931, specId: 264 }],
  },
  EARTH_ELEMENTAL_TALENT: {
    id: 198103,
    name: 'Earth Elemental',
    icon: 'spell_nature_earthelemental_totem',
    maxRanks: 1,
    entryIds: [127858],
    definitionIds: [{ id: 132667, specId: 264 }],
  },
  EARTH_SHIELD_TALENT: {
    id: 974,
    name: 'Earth Shield',
    icon: 'spell_nature_skinofearth',
    maxRanks: 1,
    entryIds: [127871],
    definitionIds: [{ id: 132680, specId: 264 }],
    manaCost: 5000,
  },
  EARTH_SHOCK_TALENT: {
    id: 8042,
    name: 'Earth Shock',
    icon: 'spell_nature_earthshock',
    maxRanks: 1,
    entryIds: [101854],
    definitionIds: [{ id: 106811, specId: 262 }],
    maelstromCost: 60,
  },
  ECHO_CHAMBER_TALENT: {
    id: 382032,
    name: 'Echo Chamber',
    icon: 'spell_nature_lightningoverload',
    maxRanks: 1,
    entryIds: [101892],
    definitionIds: [{ id: 106824, specId: 262 }],
  },
  ECHO_OF_THE_ELEMENTS_TALENT: {
    id: 333919,
    name: 'Echo of the Elements',
    icon: 'ability_shaman_echooftheelements',
    maxRanks: 1,
    entryIds: [101850, 101942],
    definitionIds: [
      { id: 106837, specId: 262 },
      { id: 106939, specId: 264 },
    ],
  },
  ELECTROSHOCK_TALENT: {
    id: 454022,
    name: 'Electroshock',
    icon: 'ability_thunderking_overcharge',
    maxRanks: 1,
    entryIds: [128226],
    definitionIds: [{ id: 133033, specId: 263 }],
  },
  ELEMENTAL_ASSAULT_TALENT: {
    id: 210853,
    name: 'Elemental Assault',
    icon: 'spell_shaman_improvedstormstrike',
    maxRanks: 1,
    entryIds: [101815],
    definitionIds: [{ id: 106893, specId: 263 }],
  },
  ELEMENTAL_ATTUNEMENT_TALENT: {
    id: 1263288,
    name: 'Elemental Attunement',
    icon: 'inv_10_elementalcombinedfoozles_primordial',
    maxRanks: 1,
    entryIds: [135983],
    definitionIds: [{ id: 140738, specId: 264 }],
  },
  ELEMENTAL_BLAST_TALENT: {
    id: 117014,
    name: 'Elemental Blast',
    icon: 'shaman_talent_elementalblast',
    maxRanks: 1,
    entryIds: [127924],
    definitionIds: [{ id: 132733, specId: 262 }],
    maelstromCost: 90,
  },
  ELEMENTAL_FURY_TALENT: {
    id: 60188,
    name: 'Elemental Fury',
    icon: 'spell_fire_volcano',
    maxRanks: 1,
    entryIds: [101853],
    definitionIds: [{ id: 106810, specId: 262 }],
  },
  ELEMENTAL_ORBIT_TALENT: {
    id: 383010,
    name: 'Elemental Orbit',
    icon: 'ability_mage_shattershield',
    maxRanks: 1,
    entryIds: [127877],
    definitionIds: [{ id: 132686, specId: 264 }],
  },
  ELEMENTAL_RESISTANCE_TALENT: {
    id: 462368,
    name: 'Elemental Resistance',
    icon: 'spell_fireresistancetotem_01',
    maxRanks: 1,
    entryIds: [127876],
    definitionIds: [{ id: 132685, specId: 264 }],
  },
  ELEMENTAL_RESONANCE_TALENT: {
    id: 1258895,
    name: 'Elemental Resonance',
    icon: 'inv_10_elementalcombinedfoozles_primordial',
    maxRanks: 1,
    entryIds: [127913],
    definitionIds: [{ id: 132722, specId: 262 }],
  },
  ELEMENTAL_REVERB_TALENT: {
    id: 443418,
    name: 'Elemental Reverb',
    icon: 'ability_shaman_echooftheelements',
    maxRanks: 1,
    entryIds: [117466],
    definitionIds: [{ id: 122478, specId: 264 }],
  },
  ELEMENTAL_TEMPO_TALENT: {
    id: 1250364,
    name: 'Elemental Tempo',
    icon: 'spell_nature_elementalprecision_1',
    maxRanks: 1,
    entryIds: [101826],
    definitionIds: [{ id: 106861, specId: 263 }],
  },
  ELEMENTAL_UNITY_TALENT: {
    id: 462866,
    name: 'Elemental Unity',
    icon: 'inv_10_elementalspiritfoozles_air',
    maxRanks: 1,
    entryIds: [127915],
    definitionIds: [{ id: 132724, specId: 262 }],
  },
  ELEMENTAL_WARDING_TALENT: {
    id: 381650,
    name: 'Elemental Warding',
    icon: 'inv_10_elementalcombinedfoozles_primordial',
    maxRanks: 1,
    entryIds: [127859],
    definitionIds: [{ id: 132668, specId: 264 }],
  },
  ELEMENTAL_WEAPONS_TALENT: {
    id: 384355,
    name: 'Elemental Weapons',
    icon: 'inv_mace_2h_draenorraid_d_03',
    maxRanks: 1,
    entryIds: [101818],
    definitionIds: [{ id: 106868, specId: 263 }],
  },
  ENCASING_COLD_TALENT: {
    id: 462762,
    name: 'Encasing Cold',
    icon: 'ability_mage_coldasice',
    maxRanks: 1,
    entryIds: [135719],
    definitionIds: [{ id: 140474, specId: 264 }],
  },
  ENHANCED_IMBUES_TALENT: {
    id: 462796,
    name: 'Enhanced Imbues',
    icon: 'spell_nature_rockbiter',
    maxRanks: 1,
    entryIds: [127881],
    definitionIds: [{ id: 132690, specId: 264 }],
  },
  EVERLASTING_ELEMENTS_TALENT: {
    id: 462867,
    name: 'Everlasting Elements',
    icon: 'spell_nature_earthelemental_totem',
    maxRanks: 1,
    entryIds: [127916],
    definitionIds: [{ id: 132725, specId: 262 }],
  },
  EYE_OF_THE_STORM_TALENT: {
    id: 381708,
    name: 'Eye of the Storm',
    icon: 'spell_shadow_soulleech_2',
    maxRanks: 1,
    entryIds: [101877],
    definitionIds: [{ id: 106827, specId: 262 }],
  },
  FEEDBACK_LOOP_1_ELEMENTAL_TALENT: {
    id: 1270061,
    name: 'Feedback Loop',
    icon: 'inv12_apextalent_shaman_feedbackloop',
    maxRanks: 1,
    entryIds: [136974],
    definitionIds: [{ id: 141737, specId: 262 }],
  },
  FEEDBACK_LOOP_2_ELEMENTAL_TALENT: {
    id: 1270062,
    name: 'Feedback Loop',
    icon: 'inv12_apextalent_shaman_feedbackloop',
    maxRanks: 2,
    entryIds: [136973],
    definitionIds: [{ id: 141736, specId: 262 }],
  },
  FEEDBACK_LOOP_3_ELEMENTAL_TALENT: {
    id: 1270064,
    name: 'Feedback Loop',
    icon: 'inv12_apextalent_shaman_feedbackloop',
    maxRanks: 1,
    entryIds: [136972],
    definitionIds: [{ id: 141735, specId: 262 }],
  },
  FERAL_SPIRIT_TALENT: {
    id: 469314,
    name: 'Feral Spirit',
    icon: 'spell_shaman_feralspirit',
    maxRanks: 1,
    entryIds: [128236],
    definitionIds: [{ id: 133043, specId: 263 }],
  },
  FINAL_CALLING_TALENT: {
    id: 443446,
    name: 'Final Calling',
    icon: 'spell_shaman_ancestralawakening',
    maxRanks: 1,
    entryIds: [117472],
    definitionIds: [{ id: 122484, specId: 264 }],
  },
  FIRE_AND_ICE_TALENT: {
    id: 382886,
    name: 'Fire and Ice',
    icon: 'spell_firefrost_orb',
    maxRanks: 1,
    entryIds: [127880],
    definitionIds: [{ id: 132689, specId: 264 }],
  },
  FIRE_NOVA_TALENT: {
    id: 1260666,
    name: 'Fire Nova',
    icon: 'spell_shaman_lavaflow',
    maxRanks: 1,
    entryIds: [136176],
    definitionIds: [{ id: 140949, specId: 263 }],
  },
  FIRST_ASCENDANT_TALENT: {
    id: 462440,
    name: 'First Ascendant',
    icon: 'spell_shaman_astralshift',
    maxRanks: 1,
    entryIds: [127921, 101913],
    definitionIds: [
      { id: 132730, specId: 262 },
      { id: 106933, specId: 264 },
    ],
  },
  FLAMES_OF_THE_CAULDRON_TALENT: {
    id: 378266,
    name: 'Flames of the Cauldron',
    icon: 'inv_misc_cauldron_fire',
    maxRanks: 1,
    entryIds: [127912],
    definitionIds: [{ id: 132721, specId: 262 }],
  },
  FLAMES_OF_THE_FIRELORD_TALENT: {
    id: 381784,
    name: 'Flames of the Firelord',
    icon: 'achievement_firelands_raid_ragnaros',
    maxRanks: 1,
    entryIds: [127922],
    definitionIds: [{ id: 132731, specId: 262 }],
  },
  FLAMETONGUE_WEAPON_TALENT: {
    id: 318038,
    name: 'Flametongue Weapon',
    icon: 'spell_fire_flametounge',
    maxRanks: 1,
    entryIds: [101879, 101805],
    definitionIds: [
      { id: 106829, specId: 262 },
      { id: 106864, specId: 263 },
    ],
  },
  FLASH_OF_LIGHTNING_TALENT: {
    id: 381936,
    name: 'Flash of Lightning',
    icon: 'spell_lightning_lightningbolt01',
    maxRanks: 1,
    entryIds: [101861],
    definitionIds: [{ id: 106843, specId: 262 }],
  },
  FLOW_OF_THE_TIDES_TALENT: {
    id: 382039,
    name: 'Flow of the Tides',
    icon: 'spell_frost_manarecharge',
    maxRanks: 1,
    entryIds: [101910],
    definitionIds: [{ id: 106943, specId: 264 }],
  },
  FLURRY_TALENT: {
    id: 382888,
    name: 'Flurry',
    icon: 'ability_ghoulfrenzy',
    maxRanks: 1,
    entryIds: [101799],
    definitionIds: [{ id: 106872, specId: 263 }],
  },
  FORCEFUL_WINDS_TALENT: {
    id: 262647,
    name: 'Forceful Winds',
    icon: 'spell_shaman_unleashweapon_wind',
    maxRanks: 1,
    entryIds: [101834],
    definitionIds: [{ id: 106888, specId: 263 }],
  },
  FROST_SHOCK_TALENT: {
    id: 196840,
    name: 'Frost Shock',
    icon: 'spell_frost_frostshock',
    maxRanks: 1,
    entryIds: [135718],
    definitionIds: [{ id: 140473, specId: 264 }],
  },
  FURY_OF_THE_STORMS_TALENT: {
    id: 191717,
    name: 'Fury of the Storms',
    icon: 'inv_stormelemental',
    maxRanks: 1,
    entryIds: [101871],
    definitionIds: [{ id: 106816, specId: 262 }],
  },
  FUSION_OF_ELEMENTS_TALENT: {
    id: 462840,
    name: 'Fusion of Elements',
    icon: 'achievement_raidprimalist_council',
    maxRanks: 1,
    entryIds: [101865],
    definitionIds: [{ id: 106841, specId: 262 }],
  },
  GRACEFUL_SPIRIT_TALENT: {
    id: 192088,
    name: 'Graceful Spirit',
    icon: 'spell_shaman_spectraltransformation',
    maxRanks: 1,
    entryIds: [127908],
    definitionIds: [{ id: 132717, specId: 264 }],
  },
  GREATER_PURGE_TALENT: {
    id: 378773,
    name: 'Greater Purge',
    icon: 'spell_shaman_focusedstrikes',
    maxRanks: 1,
    entryIds: [127904],
    definitionIds: [{ id: 132713, specId: 264 }],
    manaCost: 6000,
  },
  GUST_OF_WIND_TALENT: {
    id: 192063,
    name: 'Gust of Wind',
    icon: 'inv_misc_volatileair',
    maxRanks: 1,
    entryIds: [127864],
    definitionIds: [{ id: 132673, specId: 264 }],
  },
  HEALING_RAIN_TALENT: {
    id: 73920,
    name: 'Healing Rain',
    icon: 'spell_nature_giftofthewaterspirit',
    maxRanks: 1,
    entryIds: [101923],
    definitionIds: [{ id: 106911, specId: 264 }],
    manaCost: 10800,
  },
  HEALING_STREAM_TOTEM_RESTORATION_TALENT: {
    id: 392916,
    name: 'Healing Stream Totem',
    icon: 'inv_spear_04',
    maxRanks: 1,
    entryIds: [101900],
    definitionIds: [{ id: 106920, specId: 264 }],
  },
  HEALING_STREAM_TOTEM_SHARED_TALENT: {
    id: 392915,
    name: 'Healing Stream Totem',
    icon: 'inv_spear_04',
    maxRanks: 1,
    entryIds: [127863],
    definitionIds: [{ id: 132672, specId: 264 }],
  },
  HEALING_TIDE_TOTEM_TALENT: {
    id: 108280,
    name: 'Healing Tide Totem',
    icon: 'ability_shaman_healingtide',
    maxRanks: 1,
    entryIds: [135486],
    definitionIds: [{ id: 140243, specId: 264 }],
    manaCost: 2800,
  },
  HEED_MY_CALL_TALENT: {
    id: 443444,
    name: 'Heed My Call',
    icon: 'spell_unused2',
    maxRanks: 1,
    entryIds: [117481],
    definitionIds: [{ id: 122493, specId: 264 }],
  },
  HERALD_OF_THE_STORMS_TALENT: {
    id: 468571,
    name: 'Herald of the Storms',
    icon: 'achievement_raidprimalist_windelemental',
    maxRanks: 1,
    entryIds: [128223],
    definitionIds: [{ id: 133030, specId: 262 }],
  },
  HEX_TALENT: {
    id: 51514,
    name: 'Hex',
    icon: 'spell_shaman_hex',
    maxRanks: 1,
    entryIds: [127903],
    definitionIds: [{ id: 132712, specId: 264 }],
  },
  HOT_HAND_TALENT: {
    id: 201900,
    name: 'Hot Hand',
    icon: 'spell_fire_playingwithfire',
    maxRanks: 2,
    entryIds: [101809],
    definitionIds: [{ id: 106898, specId: 263 }],
  },
  IMBUEMENT_MASTERY_TALENT: {
    id: 445028,
    name: 'Imbuement Mastery',
    icon: 'spell_shaman_unleashweapon_wind',
    maxRanks: 1,
    entryIds: [117468],
    definitionIds: [{ id: 122480, specId: 264 }],
  },
  IMPROVED_EARTHLIVING_WEAPON_TALENT: {
    id: 382315,
    name: 'Improved Earthliving Weapon',
    icon: 'spell_shaman_giftearthmother',
    maxRanks: 1,
    entryIds: [101936],
    definitionIds: [{ id: 106938, specId: 264 }],
  },
  IMPROVED_PURIFY_SPIRIT_TALENT: {
    id: 383016,
    name: 'Improved Purify Spirit',
    icon: 'ability_shaman_cleansespirit',
    maxRanks: 1,
    entryIds: [101964],
    definitionIds: [{ id: 106962, specId: 264 }],
  },
  INFERNO_ARC_TALENT: {
    id: 1259047,
    name: 'Inferno Arc',
    icon: 'spell_shaman_shockinglava',
    maxRanks: 1,
    entryIds: [101885],
    definitionIds: [{ id: 106852, specId: 262 }],
  },
  INSTINCTIVE_IMBUEMENTS_TALENT: {
    id: 1270350,
    name: 'Instinctive Imbuements',
    icon: 'ability_shaman_ascendance',
    maxRanks: 1,
    entryIds: [135591],
    definitionIds: [{ id: 140347, specId: 264 }],
  },
  JET_STREAM_TALENT: {
    id: 462817,
    name: 'Jet Stream',
    icon: 'inv_elemental_primal_air',
    maxRanks: 1,
    entryIds: [127882],
    definitionIds: [{ id: 132691, specId: 264 }],
  },
  LASHING_FLAMES_TALENT: {
    id: 334046,
    name: 'Lashing Flames',
    icon: 'spell_shaman_shockinglava',
    maxRanks: 1,
    entryIds: [101812],
    definitionIds: [{ id: 106896, specId: 263 }],
  },
  LATENT_WISDOM_TALENT: {
    id: 443449,
    name: 'Latent Wisdom',
    icon: 'spell_holy_spiritualguidence',
    maxRanks: 1,
    entryIds: [117459],
    definitionIds: [{ id: 122471, specId: 264 }],
  },
  LAVA_BURST_TALENT: {
    id: 51505,
    name: 'Lava Burst',
    icon: 'spell_shaman_lavaburst',
    maxRanks: 1,
    entryIds: [127873],
    definitionIds: [{ id: 132682, specId: 264 }],
  },
  LAVA_FLOWS_TALENT: {
    id: 1273485,
    name: 'Lava Flows',
    icon: 'spell_shaman_lavaflow',
    maxRanks: 1,
    entryIds: [136713],
    definitionIds: [{ id: 141485, specId: 262 }],
  },
  LAVA_LASH_TALENT: {
    id: 60103,
    name: 'Lava Lash',
    icon: 'ability_shaman_lavalash',
    maxRanks: 1,
    entryIds: [135593],
    definitionIds: [{ id: 140349, specId: 263 }],
  },
  LIGHTNING_CAPACITOR_TALENT: {
    id: 462862,
    name: 'Lightning Capacitor',
    icon: 'spell_nature_lightningshield',
    maxRanks: 1,
    entryIds: [101870],
    definitionIds: [{ id: 106817, specId: 262 }],
  },
  LIGHTNING_CONDUIT_TALENT: {
    id: 467778,
    name: 'Lightning Conduit',
    icon: 'spell_shaman_staticshock',
    maxRanks: 1,
    entryIds: [117460],
    definitionIds: [{ id: 122472, specId: 263 }],
  },
  LIGHTNING_ROD_TALENT: {
    id: 210689,
    name: 'Lightning Rod',
    icon: 'inv_rod_enchantedcobalt',
    maxRanks: 1,
    entryIds: [101889],
    definitionIds: [{ id: 106838, specId: 262 }],
  },
  LIGHTNING_STRIKES_TALENT: {
    id: 384450,
    name: 'Lightning Strikes',
    icon: 'ability_thunderclap',
    maxRanks: 1,
    entryIds: [135255],
    definitionIds: [{ id: 140023, specId: 263 }],
  },
  LIVELY_TOTEMS_TALENT: {
    id: 445034,
    name: 'Lively Totems',
    icon: 'spell_fire_searingtotem',
    maxRanks: 1,
    entryIds: [117479],
    definitionIds: [{ id: 122491, specId: 264 }],
  },
  LIVING_STREAM_TALENT: {
    id: 382482,
    name: 'Living Stream',
    icon: 'spell_nature_natureresistancetotem',
    maxRanks: 1,
    entryIds: [101895],
    definitionIds: [{ id: 106925, specId: 264 }],
  },
  MAELSTROM_SUPREMACY_TALENT: {
    id: 443447,
    name: 'Maelstrom Supremacy',
    icon: 'spell_shadow_soulleech_2',
    maxRanks: 1,
    entryIds: [117480],
    definitionIds: [{ id: 122492, specId: 264 }],
  },
  MAELSTROM_WEAPON_TALENT: {
    id: 187880,
    name: 'Maelstrom Weapon',
    icon: 'spell_shaman_maelstromweapon',
    maxRanks: 1,
    entryIds: [101804],
    definitionIds: [{ id: 106862, specId: 263 }],
  },
  MANA_SPRING_TALENT: {
    id: 381930,
    name: 'Mana Spring',
    icon: 'spell_nature_manaregentotem',
    maxRanks: 1,
    entryIds: [127860],
    definitionIds: [{ id: 132669, specId: 264 }],
  },
  MASTER_OF_THE_ELEMENTS_TALENT: {
    id: 16166,
    name: 'Master of the Elements',
    icon: 'spell_nature_elementalabsorption',
    maxRanks: 1,
    entryIds: [136714],
    definitionIds: [{ id: 141486, specId: 262 }],
  },
  MOLTEN_ASSAULT_TALENT: {
    id: 334033,
    name: 'Molten Assault',
    icon: 'spell_fire_ragnaros_lavabolt',
    maxRanks: 1,
    entryIds: [101806],
    definitionIds: [{ id: 106863, specId: 263 }],
  },
  MOLTEN_WRATH_TALENT: {
    id: 1258843,
    name: 'Molten Wrath',
    icon: 'spell_shaman_lavaburst',
    maxRanks: 1,
    entryIds: [101872],
    definitionIds: [{ id: 106832, specId: 262 }],
  },
  MOUNTAINS_WILL_FALL_TALENT: {
    id: 381726,
    name: 'Mountains Will Fall',
    icon: 'inv_elementalearth2',
    maxRanks: 1,
    entryIds: [101876],
    definitionIds: [{ id: 106826, specId: 262 }],
  },
  MYSTIC_KNOWLEDGE_TALENT: {
    id: 1270450,
    name: 'Mystic Knowledge',
    icon: 'achievement_raidprimalist_council',
    maxRanks: 1,
    entryIds: [135988],
    definitionIds: [{ id: 140743, specId: 264 }],
  },
  NATURAL_GIFT_TALENT: {
    id: 1264691,
    name: 'Natural Gift',
    icon: 'spell_shaman_maelstromweapon',
    maxRanks: 1,
    entryIds: [135986],
    definitionIds: [{ id: 140741, specId: 263 }],
  },
  NATURAL_HARMONY_TALENT: {
    id: 443442,
    name: 'Natural Harmony',
    icon: 'spell_nature_natureguardian',
    maxRanks: 1,
    entryIds: [117455],
    definitionIds: [{ id: 122467, specId: 264 }],
  },
  NATURES_FURY_TALENT: {
    id: 381655,
    name: "Nature's Fury",
    icon: 'spell_nature_spiritarmor',
    maxRanks: 2,
    entryIds: [127894],
    definitionIds: [{ id: 132703, specId: 264 }],
  },
  NATURES_GUARDIAN_TALENT: {
    id: 30884,
    name: "Nature's Guardian",
    icon: 'spell_nature_natureguardian',
    maxRanks: 1,
    entryIds: [127890],
    definitionIds: [{ id: 132699, specId: 264 }],
  },
  NATURES_PROTECTION_TALENT: {
    id: 454027,
    name: "Nature's Protection",
    icon: 'spell_nature_lightningshield',
    maxRanks: 1,
    entryIds: [117477],
    definitionIds: [{ id: 122489, specId: 263 }],
  },
  NATURES_SWIFTNESS_TALENT: {
    id: 378081,
    name: "Nature's Swiftness",
    icon: 'spell_nature_ravenform',
    maxRanks: 1,
    entryIds: [127899],
    definitionIds: [{ id: 132708, specId: 264 }],
  },
  OFFERING_FROM_BEYOND_TALENT: {
    id: 443451,
    name: 'Offering from Beyond',
    icon: 'spell_shaman_blessingoftheeternals',
    maxRanks: 1,
    entryIds: [117484],
    definitionIds: [{ id: 122496, specId: 264 }],
  },
  OVERCHARGE_TALENT: {
    id: 1251026,
    name: 'Overcharge',
    icon: 'spell_nature_unrelentingstorm',
    maxRanks: 1,
    entryIds: [101808],
    definitionIds: [{ id: 106900, specId: 263 }],
  },
  OVERFLOWING_MAELSTROM_TALENT: {
    id: 384143,
    name: 'Overflowing Maelstrom',
    icon: 'inv_magic_swirl_color3',
    maxRanks: 1,
    entryIds: [101802],
    definitionIds: [{ id: 106871, specId: 263 }],
  },
  OVERFLOWING_SHORES_TALENT: {
    id: 383222,
    name: 'Overflowing Shores',
    icon: 'spell_nature_giftofthewaterspirit',
    maxRanks: 1,
    entryIds: [114813],
    definitionIds: [{ id: 119820, specId: 264 }],
  },
  OVERSIZED_TOTEMS_TALENT: {
    id: 445026,
    name: 'Oversized Totems',
    icon: 'ability_shaman_totemrelocation',
    maxRanks: 1,
    entryIds: [117456],
    definitionIds: [{ id: 122468, specId: 264 }],
  },
  OVERSURGE_TALENT: {
    id: 445030,
    name: 'Oversurge',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [125823],
    definitionIds: [{ id: 130654, specId: 264 }],
  },
  PATH_OF_THE_SEER_TALENT: {
    id: 1269364,
    name: 'Path of the Seer',
    icon: 'spell_shaman_elementaloath',
    maxRanks: 1,
    entryIds: [136561],
    definitionIds: [{ id: 141334, specId: 262 }],
  },
  PLANES_TRAVELER_TALENT: {
    id: 381647,
    name: 'Planes Traveler',
    icon: 'spell_shaman_astralshift',
    maxRanks: 1,
    entryIds: [127888],
    definitionIds: [{ id: 132697, specId: 264 }],
  },
  POISON_CLEANSING_TOTEM_TALENT: {
    id: 383013,
    name: 'Poison Cleansing Totem',
    icon: 'spell_nature_poisoncleansingtotem',
    maxRanks: 1,
    entryIds: [136567],
    definitionIds: [{ id: 141340, specId: 264 }],
  },
  POWER_OF_THE_MAELSTROM_TALENT: {
    id: 191861,
    name: 'Power of the Maelstrom',
    icon: 'spell_fire_masterofelements',
    maxRanks: 1,
    entryIds: [101869],
    definitionIds: [{ id: 106823, specId: 262 }],
  },
  PREEMINENCE_TALENT: {
    id: 462443,
    name: 'Preeminence',
    icon: 'spell_shaman_improvedreincarnation',
    maxRanks: 1,
    entryIds: [128224, 135485],
    definitionIds: [
      { id: 133031, specId: 262 },
      { id: 140242, specId: 264 },
    ],
  },
  PRIMAL_CATALYST_TALENT: {
    id: 1260874,
    name: 'Primal Catalyst',
    icon: 'misc_legionfall_shaman',
    maxRanks: 1,
    entryIds: [135982],
    definitionIds: [{ id: 140737, specId: 264 }],
  },
  PRIMAL_ELEMENTALIST_TALENT: {
    id: 117013,
    name: 'Primal Elementalist',
    icon: 'shaman_talent_primalelementalist',
    maxRanks: 1,
    entryIds: [101844],
    definitionIds: [{ id: 106856, specId: 262 }],
  },
  PRIMAL_TIDE_CORE_TALENT: {
    id: 382045,
    name: 'Primal Tide Core',
    icon: 'ability_shaman_repulsiontotem',
    maxRanks: 1,
    entryIds: [101842],
    definitionIds: [{ id: 106901, specId: 264 }],
  },
  PRIMORDIAL_BOND_TALENT: {
    id: 1279819,
    name: 'Primordial Bond',
    icon: 'inv_elemental_primal_earth',
    maxRanks: 1,
    entryIds: [127889],
    definitionIds: [{ id: 132698, specId: 264 }],
  },
  PRIMORDIAL_CAPACITY_TALENT: {
    id: 443448,
    name: 'Primordial Capacity',
    icon: 'ability_monk_chiswirl',
    maxRanks: 1,
    entryIds: [117457],
    definitionIds: [{ id: 122469, specId: 264 }],
  },
  PRIMORDIAL_FURY_TALENT: {
    id: 378193,
    name: 'Primordial Fury',
    icon: 'inv_10_elementalshardfoozles_primordial',
    maxRanks: 1,
    entryIds: [127920],
    definitionIds: [{ id: 132729, specId: 262 }],
  },
  PRIMORDIAL_STORM_TALENT: {
    id: 1218047,
    name: 'Primordial Storm',
    icon: 'ability_shaman_ascendance',
    maxRanks: 1,
    entryIds: [101828],
    definitionIds: [{ id: 106883, specId: 263 }],
  },
  PULSE_CAPACITOR_TALENT: {
    id: 445032,
    name: 'Pulse Capacitor',
    icon: 'spell_nature_elementalprecision_1',
    maxRanks: 1,
    entryIds: [117463],
    definitionIds: [{ id: 122475, specId: 264 }],
  },
  PURGE_TALENT: {
    id: 370,
    name: 'Purge',
    icon: 'spell_nature_purge',
    maxRanks: 1,
    entryIds: [127905],
    definitionIds: [{ id: 132714, specId: 264 }],
    manaCost: 4000,
  },
  PURGING_FLAMES_TALENT: {
    id: 1259471,
    name: 'Purging Flames',
    icon: 'inv12_ability_shaman_purgingflames',
    maxRanks: 1,
    entryIds: [101884],
    definitionIds: [{ id: 106851, specId: 262 }],
  },
  QUICKSTREAM_TALENT: {
    id: 1253099,
    name: 'Quickstream',
    icon: 'inv_spear_04',
    maxRanks: 1,
    entryIds: [101934],
    definitionIds: [{ id: 106927, specId: 264 }],
  },
  RAGING_MAELSTROM_TALENT: {
    id: 384149,
    name: 'Raging Maelstrom',
    icon: 'spell_nature_elementalabsorption',
    maxRanks: 1,
    entryIds: [101801],
    definitionIds: [{ id: 106880, specId: 263 }],
  },
  REACTIVE_WARDING_TALENT: {
    id: 462454,
    name: 'Reactive Warding',
    icon: 'inv_10_elementalcombinedfoozles_water',
    maxRanks: 1,
    entryIds: [136584],
    definitionIds: [{ id: 141357, specId: 264 }],
  },
  REFRESHING_WATERS_TALENT: {
    id: 378211,
    name: 'Refreshing Waters',
    icon: 'ability_shaman_fortifyingwaters',
    maxRanks: 1,
    entryIds: [127869],
    definitionIds: [{ id: 132678, specId: 264 }],
  },
  RESURGENCE_TALENT: {
    id: 16196,
    name: 'Resurgence',
    icon: 'ability_shaman_watershield',
    maxRanks: 1,
    entryIds: [101902],
    definitionIds: [{ id: 106916, specId: 264 }],
  },
  RIDE_THE_LIGHTNING_TALENT: {
    id: 289874,
    name: 'Ride the Lightning',
    icon: 'ability_thunderking_balllightning',
    maxRanks: 1,
    entryIds: [101827],
    definitionIds: [{ id: 106860, specId: 263 }],
  },
  RIPTIDE_TALENT: {
    id: 61295,
    name: 'Riptide',
    icon: 'spell_nature_riptide',
    maxRanks: 1,
    entryIds: [101905],
    definitionIds: [{ id: 106805, specId: 264 }],
    manaCost: 3800,
  },
  RIP_CURRENT_TALENT: {
    id: 1254251,
    name: 'Rip Current',
    icon: 'spell_frost_summonwaterelemental',
    maxRanks: 1,
    entryIds: [135487],
    definitionIds: [{ id: 140244, specId: 264 }],
  },
  ROLLING_THUNDER_TALENT: {
    id: 454026,
    name: 'Rolling Thunder',
    icon: 'spell_lightning_lightningbolt01',
    maxRanks: 1,
    entryIds: [117486],
    definitionIds: [{ id: 122498, specId: 263 }],
  },
  ROUTINE_COMMUNICATION_TALENT: {
    id: 443445,
    name: 'Routine Communication',
    icon: 'spell_nature_undyingstrength',
    maxRanks: 1,
    entryIds: [123630],
    definitionIds: [{ id: 128468, specId: 264 }],
  },
  SEARING_FLAMES_TALENT: {
    id: 381782,
    name: 'Searing Flames',
    icon: 'inv_offhand_1h_artifactdoomhammer_d_01',
    maxRanks: 1,
    entryIds: [101880],
    definitionIds: [{ id: 106847, specId: 262 }],
  },
  SOOTHING_RAIN_TALENT: {
    id: 1252874,
    name: 'Soothing Rain',
    icon: 'spell_shadow_soulleech_2',
    maxRanks: 1,
    entryIds: [127672],
    definitionIds: [{ id: 132481, specId: 264 }],
  },
  SPIRITUAL_AWAKENING_TALENT: {
    id: 1270375,
    name: 'Spiritual Awakening',
    icon: 'spell_shaman_blessingoftheeternals',
    maxRanks: 1,
    entryIds: [136585],
    definitionIds: [{ id: 141358, specId: 264 }],
  },
  SPIRITWALKERS_AEGIS_TALENT: {
    id: 378077,
    name: "Spiritwalker's Aegis",
    icon: 'ability_racial_forceshield',
    maxRanks: 1,
    entryIds: [127907],
    definitionIds: [{ id: 132716, specId: 264 }],
  },
  SPIRITWALKERS_GRACE_TALENT: {
    id: 79206,
    name: "Spiritwalker's Grace",
    icon: 'spell_shaman_spiritwalkersgrace',
    maxRanks: 1,
    entryIds: [127857],
    definitionIds: [{ id: 132666, specId: 264 }],
    manaCost: 7050,
  },
  SPIRITWALKERS_MOMENTUM_TALENT: {
    id: 443425,
    name: "Spiritwalker's Momentum",
    icon: 'spell_shaman_spiritwalkersgrace',
    maxRanks: 1,
    entryIds: [117458],
    definitionIds: [{ id: 122470, specId: 264 }],
  },
  SPIRIT_LINK_TOTEM_TALENT: {
    id: 98008,
    name: 'Spirit Link Totem',
    icon: 'spell_shaman_spiritlink',
    maxRanks: 1,
    entryIds: [101924],
    definitionIds: [{ id: 106915, specId: 264 }],
    manaCost: 5500,
  },
  SPIRIT_WALK_TALENT: {
    id: 58875,
    name: 'Spirit Walk',
    icon: 'ability_tracking',
    maxRanks: 1,
    entryIds: [127865],
    definitionIds: [{ id: 132674, specId: 264 }],
  },
  SPIRIT_WOLF_TALENT: {
    id: 260878,
    name: 'Spirit Wolf',
    icon: 'spell_hunter_lonewolf',
    maxRanks: 1,
    entryIds: [127854],
    definitionIds: [{ id: 132663, specId: 264 }],
  },
  SPLITSTREAM_TALENT: {
    id: 445035,
    name: 'Splitstream',
    icon: 'ability_rhyolith_lavapool',
    maxRanks: 1,
    entryIds: [117469],
    definitionIds: [{ id: 122481, specId: 264 }],
  },
  SPOUTING_SPIRITS_TALENT: {
    id: 462383,
    name: 'Spouting Spirits',
    icon: 'spell_shaman_spiritlink',
    maxRanks: 1,
    entryIds: [128332],
    definitionIds: [{ id: 133139, specId: 264 }],
  },
  STATIC_ACCUMULATION_TALENT: {
    id: 384411,
    name: 'Static Accumulation',
    icon: 'spell_nature_callstorm',
    maxRanks: 2,
    entryIds: [101814],
    definitionIds: [{ id: 106881, specId: 263 }],
  },
  STATIC_CHARGE_TALENT: {
    id: 265046,
    name: 'Static Charge',
    icon: 'spell_nature_brilliance',
    maxRanks: 2,
    entryIds: [127896],
    definitionIds: [{ id: 132705, specId: 264 }],
  },
  STORMBIND_TALENT: {
    id: 1251069,
    name: 'Stormbind',
    icon: 'ability_siege_engineer_magnetic_lasso',
    maxRanks: 1,
    entryIds: [135253],
    definitionIds: [{ id: 140021, specId: 263 }],
  },
  STORMBLAST_TALENT: {
    id: 319930,
    name: 'Stormblast',
    icon: 'spell_shaman_focusedstrikes',
    maxRanks: 1,
    entryIds: [101825],
    definitionIds: [{ id: 106877, specId: 263 }],
  },
  STORMCALLER_TALENT: {
    id: 454021,
    name: 'Stormcaller',
    icon: 'ability_vehicle_electrocharge',
    maxRanks: 1,
    entryIds: [117490],
    definitionIds: [{ id: 122502, specId: 263 }],
  },
  STORMFLURRY_TALENT: {
    id: 344357,
    name: 'Stormflurry',
    icon: 'ability_shaman_stormstrike',
    maxRanks: 1,
    entryIds: [128270],
    definitionIds: [{ id: 133077, specId: 263 }],
  },
  STORMKEEPER_TALENT: {
    id: 191634,
    name: 'Stormkeeper',
    icon: 'ability_thunderking_lightningwhip',
    maxRanks: 1,
    entryIds: [101859],
    definitionIds: [{ id: 106819, specId: 262 }],
  },
  STORMSTREAM_TOTEM_1_RESTORATION_TALENT: {
    id: 1267016,
    name: 'Stormstream Totem',
    icon: 'inv12_apextalent_shaman_stormstreamtotem',
    maxRanks: 1,
    entryIds: [136977],
    definitionIds: [{ id: 141740, specId: 264 }],
  },
  STORMSTREAM_TOTEM_2_RESTORATION_TALENT: {
    id: 1267093,
    name: 'Stormstream Totem',
    icon: 'inv12_apextalent_shaman_stormstreamtotem',
    maxRanks: 2,
    entryIds: [136976],
    definitionIds: [{ id: 141739, specId: 264 }],
  },
  STORMSTREAM_TOTEM_3_RESTORATION_TALENT: {
    id: 1267120,
    name: 'Stormstream Totem',
    icon: 'inv12_apextalent_shaman_stormstreamtotem',
    maxRanks: 1,
    entryIds: [136975],
    definitionIds: [{ id: 141738, specId: 264 }],
  },
  STORMS_WRATH_TALENT: {
    id: 392352,
    name: "Storm's Wrath",
    icon: 'spell_nature_stormreach',
    maxRanks: 1,
    entryIds: [101832],
    definitionIds: [{ id: 107009, specId: 263 }],
  },
  STORMWELL_TALENT: {
    id: 1264762,
    name: 'Stormwell',
    icon: 'inv_112_raidtrinkets_etherealenergystoragesphere_purple',
    maxRanks: 1,
    entryIds: [135987],
    definitionIds: [{ id: 140742, specId: 263 }],
  },
  STORM_FRENZY_TALENT: {
    id: 462695,
    name: 'Storm Frenzy',
    icon: 'spell_nature_callstorm',
    maxRanks: 1,
    entryIds: [127917],
    definitionIds: [{ id: 132726, specId: 262 }],
  },
  STORM_INFUSION_TALENT: {
    id: 1258889,
    name: 'Storm Infusion',
    icon: 'inv_misc_stormlordsfavor',
    maxRanks: 1,
    entryIds: [127918],
    definitionIds: [{ id: 132727, specId: 262 }],
  },
  STORM_SWELL_TALENT: {
    id: 455088,
    name: 'Storm Swell',
    icon: 'spell_nature_unrelentingstorm',
    maxRanks: 1,
    entryIds: [117470],
    definitionIds: [{ id: 122482, specId: 263 }],
  },
  STORM_UNLEASHED_1_ENHANCEMENT_TALENT: {
    id: 1262713,
    name: 'Storm Unleashed',
    icon: 'inv12_apextalent_shaman_stormunleashed',
    maxRanks: 1,
    entryIds: [136971],
    definitionIds: [{ id: 141734, specId: 263 }],
  },
  STORM_UNLEASHED_2_ENHANCEMENT_TALENT: {
    id: 1262761,
    name: 'Storm Unleashed',
    icon: 'spell_druid_astralstorm',
    maxRanks: 2,
    entryIds: [136970],
    definitionIds: [{ id: 141733, specId: 263 }],
  },
  STORM_UNLEASHED_3_ENHANCEMENT_TALENT: {
    id: 1252373,
    name: 'Storm Unleashed',
    icon: 'spell_druid_astralstorm',
    maxRanks: 1,
    entryIds: [136969],
    definitionIds: [{ id: 141732, specId: 263 }],
  },
  SUNDERING_TALENT: {
    id: 197214,
    name: 'Sundering',
    icon: 'ability_rhyolith_lavapool',
    maxRanks: 1,
    entryIds: [101841],
    definitionIds: [{ id: 106874, specId: 263 }],
    manaCost: 3000,
  },
  SUPERCHARGE_TALENT: {
    id: 455110,
    name: 'Supercharge',
    icon: 'inv_misc_stormlordsfavor',
    maxRanks: 1,
    entryIds: [128225],
    definitionIds: [{ id: 133032, specId: 263 }],
  },
  SUPPORTIVE_IMBUEMENTS_TALENT: {
    id: 445033,
    name: 'Supportive Imbuements',
    icon: 'ability_shaman_fortifyingwaters',
    maxRanks: 1,
    entryIds: [125824],
    definitionIds: [{ id: 130655, specId: 264 }],
  },
  SURGING_CURRENTS_TALENT: {
    id: 454372,
    name: 'Surging Currents',
    icon: 'ability_thunderking_thunderstruck',
    maxRanks: 1,
    entryIds: [125617],
    definitionIds: [{ id: 130449, specId: 263 }],
  },
  SURGING_ELEMENTS_TALENT: {
    id: 382042,
    name: 'Surging Elements',
    icon: 'item_sparkofragnoros',
    maxRanks: 1,
    entryIds: [101829],
    definitionIds: [{ id: 106884, specId: 263 }],
  },
  SURGING_TOTEM_TALENT: {
    id: 455630,
    name: 'Surging Totem',
    icon: 'inv_ability_totemicshaman_surgingtotem',
    maxRanks: 1,
    entryIds: [117474],
    definitionIds: [{ id: 122486, specId: 264 }],
  },
  SWELLING_MAELSTROM_TALENT: {
    id: 381707,
    name: 'Swelling Maelstrom',
    icon: 'spell_shaman_maelstromweapon',
    maxRanks: 1,
    entryIds: [101893],
    definitionIds: [{ id: 106815, specId: 262 }],
  },
  SWIFT_RECALL_TALENT: {
    id: 445027,
    name: 'Swift Recall',
    icon: 'spell_nature_brilliance',
    maxRanks: 1,
    entryIds: [125825],
    definitionIds: [{ id: 130656, specId: 264 }],
  },
  TECTONIC_COLLAPSE_TALENT: {
    id: 1258899,
    name: 'Tectonic Collapse',
    icon: 'item_earthenmight',
    maxRanks: 1,
    entryIds: [101874],
    definitionIds: [{ id: 106831, specId: 262 }],
  },
  TEMPEST_TALENT: {
    id: 454009,
    name: 'Tempest',
    icon: 'inv_ability_stormcallershaman_tempest',
    maxRanks: 1,
    entryIds: [117489],
    definitionIds: [{ id: 122501, specId: 263 }],
  },
  THERAZANES_RESILIENCE_TALENT: {
    id: 1217622,
    name: "Therazane's Resilience",
    icon: 'shaman_pvp_rockshield',
    maxRanks: 1,
    entryIds: [127868],
    definitionIds: [{ id: 132677, specId: 264 }],
  },
  THORIMS_INVOCATION_TALENT: {
    id: 384444,
    name: "Thorim's Invocation",
    icon: 'spell_shaman_ancestralawakening',
    maxRanks: 1,
    entryIds: [101813],
    definitionIds: [{ id: 106882, specId: 263 }],
  },
  THUNDEROUS_PAWS_TALENT: {
    id: 378075,
    name: 'Thunderous Paws',
    icon: 'ability_hunter_longevity',
    maxRanks: 1,
    entryIds: [127853],
    definitionIds: [{ id: 132662, specId: 264 }],
  },
  THUNDERSTRIKE_WARD_TALENT: {
    id: 462757,
    name: 'Thunderstrike Ward',
    icon: 'inv_armorkit_lightning_imbued',
    maxRanks: 1,
    entryIds: [135716],
    definitionIds: [{ id: 140471, specId: 262 }],
  },
  THUNDER_CAPACITOR_TALENT: {
    id: 1262635,
    name: 'Thunder Capacitor',
    icon: 'ability_thunderking_thunderstruck',
    maxRanks: 1,
    entryIds: [135252],
    definitionIds: [{ id: 140020, specId: 263 }],
  },
  TIDAL_WAVES_TALENT: {
    id: 51564,
    name: 'Tidal Waves',
    icon: 'spell_shaman_tidalwaves',
    maxRanks: 1,
    entryIds: [101928],
    definitionIds: [{ id: 106941, specId: 264 }],
  },
  TIDEWATERS_TALENT: {
    id: 462424,
    name: 'Tidewaters',
    icon: 'ability_shawaterelemental_split',
    maxRanks: 1,
    entryIds: [127679],
    definitionIds: [{ id: 132488, specId: 264 }],
  },
  TORRENT_TALENT: {
    id: 200072,
    name: 'Torrent',
    icon: 'spell_nature_riptide',
    maxRanks: 1,
    entryIds: [127678],
    definitionIds: [{ id: 132487, specId: 264 }],
  },
  TOTEMIC_COORDINATION_TALENT: {
    id: 445036,
    name: 'Totemic Coordination',
    icon: 'ability_shaman_echooftheelements',
    maxRanks: 1,
    entryIds: [117478],
    definitionIds: [{ id: 122490, specId: 264 }],
  },
  TOTEMIC_FOCUS_TALENT: {
    id: 382201,
    name: 'Totemic Focus',
    icon: 'inv_relics_totemofrebirth',
    maxRanks: 1,
    entryIds: [127906],
    definitionIds: [{ id: 132715, specId: 264 }],
  },
  TOTEMIC_MOMENTUM_TALENT: {
    id: 1260644,
    name: 'Totemic Momentum',
    icon: 'spell_frost_fireresistancetotem',
    maxRanks: 1,
    entryIds: [135984],
    definitionIds: [{ id: 140739, specId: 264 }],
  },
  TOTEMIC_PROJECTION_TALENT: {
    id: 108287,
    name: 'Totemic Projection',
    icon: 'ability_shaman_totemrelocation',
    maxRanks: 1,
    entryIds: [135590],
    definitionIds: [{ id: 140346, specId: 264 }],
  },
  TOTEMIC_REBOUND_TALENT: {
    id: 445025,
    name: 'Totemic Rebound',
    icon: 'ability_vehicle_electrocharge',
    maxRanks: 1,
    entryIds: [117487],
    definitionIds: [{ id: 122499, specId: 264 }],
  },
  TOTEMIC_SURGE_TALENT: {
    id: 381867,
    name: 'Totemic Surge',
    icon: 'spell_nature_agitatingtotem',
    maxRanks: 1,
    entryIds: [135592],
    definitionIds: [{ id: 140348, specId: 264 }],
  },
  TREMOR_TOTEM_TALENT: {
    id: 8143,
    name: 'Tremor Totem',
    icon: 'spell_nature_tremortotem',
    maxRanks: 1,
    entryIds: [127874],
    definitionIds: [{ id: 132683, specId: 264 }],
  },
  UNDERCURRENT_TALENT: {
    id: 382194,
    name: 'Undercurrent',
    icon: 'spell_fire_bluehellfire',
    maxRanks: 2,
    entryIds: [101939],
    definitionIds: [{ id: 106935, specId: 264 }],
  },
  UNLEASH_LIFE_TALENT: {
    id: 73685,
    name: 'Unleash Life',
    icon: 'spell_shaman_unleashweapon_life',
    maxRanks: 1,
    entryIds: [114811],
    definitionIds: [{ id: 119818, specId: 264 }],
  },
  UNLIMITED_POWER_TALENT: {
    id: 454391,
    name: 'Unlimited Power',
    icon: 'spell_nature_purge',
    maxRanks: 1,
    entryIds: [117483],
    definitionIds: [{ id: 122495, specId: 263 }],
  },
  UNRULY_WINDS_TALENT: {
    id: 390288,
    name: 'Unruly Winds',
    icon: 'ability_skyreach_wind_wall',
    maxRanks: 1,
    entryIds: [101833],
    definitionIds: [{ id: 106887, specId: 263 }],
  },
  VOLTAIC_BLAZE_TALENT: {
    id: 470057,
    name: 'Voltaic Blaze',
    icon: 'inv_10_dungeonjewelry_primalist_trinket_1ragingelement_fire',
    maxRanks: 1,
    entryIds: [101883, 101819],
    definitionIds: [
      { id: 106850, specId: 262 },
      { id: 106869, specId: 263 },
    ],
  },
  VOLTAIC_SURGE_TALENT: {
    id: 454919,
    name: 'Voltaic Surge',
    icon: 'spell_nature_callstorm',
    maxRanks: 1,
    entryIds: [117467],
    definitionIds: [{ id: 122479, specId: 263 }],
  },
  VOODOO_MASTERY_TALENT: {
    id: 204268,
    name: 'Voodoo Mastery',
    icon: 'spell_shaman_hex',
    maxRanks: 1,
    entryIds: [127875],
    definitionIds: [{ id: 132684, specId: 264 }],
  },
  WATER_EXPULSION_TALENT: {
    id: 1253014,
    name: 'Water Expulsion',
    icon: 'inv_elemental_primal_water',
    maxRanks: 1,
    entryIds: [127680],
    definitionIds: [{ id: 132489, specId: 264 }],
  },
  WATER_TOTEM_MASTERY_TALENT: {
    id: 382030,
    name: 'Water Totem Mastery',
    icon: 'ability_shaman_totemcooldownrefund',
    maxRanks: 1,
    entryIds: [101899],
    definitionIds: [{ id: 106921, specId: 264 }],
  },
  WAVESPEAKERS_BLESSING_TALENT: {
    id: 381946,
    name: "Wavespeaker's Blessing",
    icon: 'inv_alchemist_81_spiritedalchemiststone',
    maxRanks: 2,
    entryIds: [127671],
    definitionIds: [{ id: 132480, specId: 264 }],
  },
  WHIRLING_ELEMENTS_TALENT: {
    id: 445024,
    name: 'Whirling Elements',
    icon: 'inv_10_enchanting2_elementalswirl_color1',
    maxRanks: 1,
    entryIds: [117476],
    definitionIds: [{ id: 122488, specId: 264 }],
  },
  WHITE_WATER_TALENT: {
    id: 462587,
    name: 'White Water',
    icon: 'ability_shawaterelemental_swirl',
    maxRanks: 1,
    entryIds: [101932],
    definitionIds: [{ id: 106929, specId: 264 }],
  },
  WINDFURY_WEAPON_TALENT: {
    id: 33757,
    name: 'Windfury Weapon',
    icon: 'spell_shaman_unleashweapon_wind',
    maxRanks: 1,
    entryIds: [101823],
    definitionIds: [{ id: 106876, specId: 263 }],
  },
  WINDSPEAKER_TALENT: {
    id: 1270447,
    name: 'Windspeaker',
    icon: 'achievement_raidprimalist_windelemental',
    maxRanks: 1,
    entryIds: [135989],
    definitionIds: [{ id: 140744, specId: 264 }],
  },
  WINDS_OF_ALAKIR_TALENT: {
    id: 382215,
    name: "Winds of Al'Akir",
    icon: 'ability_druid_galewinds',
    maxRanks: 2,
    entryIds: [127891],
    definitionIds: [{ id: 132700, specId: 264 }],
  },
  WINDVEIL_TALENT: {
    id: 355630,
    name: 'Windveil',
    icon: 'inv_elemental_primal_air',
    maxRanks: 1,
    entryIds: [127910],
    definitionIds: [{ id: 132719, specId: 264 }],
  },
  WIND_BARRIER_TALENT: {
    id: 445031,
    name: 'Wind Barrier',
    icon: 'spell_nature_eyeofthestorm',
    maxRanks: 1,
    entryIds: [117488],
    definitionIds: [{ id: 122500, specId: 264 }],
  },
  WIND_RUSH_TOTEM_TALENT: {
    id: 192077,
    name: 'Wind Rush Totem',
    icon: 'ability_shaman_windwalktotem',
    maxRanks: 1,
    entryIds: [127909],
    definitionIds: [{ id: 132718, specId: 264 }],
    manaCost: 2500,
  },
  WIND_SHEAR_TALENT: {
    id: 57994,
    name: 'Wind Shear',
    icon: 'spell_nature_cyclone',
    maxRanks: 1,
    entryIds: [127892],
    definitionIds: [{ id: 132701, specId: 264 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_SHAMAN };
